export default __webpack_public_path__ + "static/media/Mark-6-Suit-08.6df1a1be.jpg";